/** Traductions workerDashboardModal (FR / AR) */
export const workerDashboardModalFr = {
  "title": "POS",
  "hello": "Bonjour",
  "close": "Fermer",
  "tabOverview": "Aperçu",
  "tabActiveSession": "Session Active",
  "tabReports": "Rapports",
  "tabNotifications": "Notifications",
  "tabDeviations": "Écarts",
  "bienvenueDansVotreTableauBord": "Bienvenue dans votre tableau de bord",
  "gerezVosVentesSuivezVos": "Gérez vos ventes et suivez vos performances",
  "totalVentes": "Total des ventes",
  "sessions": "Sessions",
  "detailPaiementsElectroniques": "Détail des paiements électroniques",
  "totalPaiementsElectroniques": "Total des paiements électroniques",
  "totalVentes2": "du total des ventes",
  "transaction": "transaction",
  "totalElectronique": "du total électronique",
  "totalEspeces": "Total en espèces",
  "ceMois": "Ce Mois",
  "totalElectronique2": "Total électronique",
  "detailMethodes": "Détail des Méthodes",
  "plus": "plus",
  "ventes": "ventes",
  "statutEvaluation": "Statut d'évaluation",
  "masquer": "Masquer",
  "afficher": "Afficher",
  "utilise": "Utilisé",
  "limite": "Limite",
  "maSessionActive": "Ma Session Active",
  "aucuneSessionActive": "Aucune session active",
  "vousNAvezPasEncore": "Vous n'avez pas encore commencé de session de travail",
  "commencee": "Commencée à",
  "duree": "Durée",
  "resumeSession": "Résumé de session",
  "indicateur": "Indicateur",
  "cash": "Espèces",
  "electronic": "Électronique",
  "debutSession": "Début de session",
  "ventesSession": "Ventes de session",
  "debtCollectionsSession": "Encaissements créances",
  "sortiesSession": "Sorties de session",
  "expected": "Attendu",
  "electroniqueFournisseur": "Électronique par fournisseur",
  "provider": "Fournisseur",
  "amount": "Montant",
  "aucuneTransactionElectroniqueMoment": "Aucune transaction électronique pour le moment",
  "unspecified": "Non précisé",
  "ventesDansCetteSession": "Ventes dans cette session",
  "vente": "Vente",
  "terminerCetteSessionUtilisezBouton": "Pour terminer cette session, utilisez le bouton de déconnexion",
  "toutesDonneesSessionSerontSauvegardees": "Toutes les données de session seront sauvegardées automatiquement",
  "mesRapportsPersonnels": "Mes rapports personnels",
  "filtrerSessions": "Filtrer les sessions",
  "toutes": "Toutes",
  "aujourdHui": "Aujourd'hui",
  "cetteSemaine": "Cette semaine",
  "statistiquesMoisActuel": "Statistiques du mois actuel",
  "moyenneSession": "Moyenne par session",
  "especes": "% en espèces",
  "sessionsTravail": "Sessions de travail",
  "session": "Session",
  "periode": "Période",
  "status": "Statut",
  "debutEspeces": "Début espèces",
  "finEspeces": "Fin espèces",
  "debutElectronique": "Début électronique",
  "sales": "Ventes",
  "cours": "En cours",
  "terminee": "Terminée",
  "statusActive": "Active",
  "aucuneSessionTrouvee": "Aucune session trouvée",
  "ventesRecentes": "Ventes récentes",
  "reference": "Référence",
  "date": "Date",
  "modePaiement": "Mode de paiement",
  "aucuneVenteRecente": "Aucune vente récente",
  "analyseDetailleeMethodesPaiementElectroniques": "Analyse détaillée des méthodes de paiement électroniques",
  "methodePaiement": "Méthode de Paiement",
  "transactions": "Transactions",
  "part": "Part",
  "mesNotifications": "Mes Notifications",
  "aucuneNotification": "Aucune notification",
  "mesEcarts": "Mes Écarts",
  "typeSelf": "Écart Personnel",
  "statusAccepted": "Accepté",
  "statusRejected": "Rejeté",
  "statusPending": "En attente",
  "explication": "Explication",
  "typeHandover": "Écart de Remise",
  "aucunEcart": "Aucun écart",
  "monthSummaryTitle": "Résumé du mois en cours",
  "periodSummaryTitle": "Résumé de la période filtrée",
  "columnIndicator": "Indicateur",
  "columnCount": "Nombre",
  "columnAmount": "Montant",
  "salesCount": "Nombre de ventes",
  "salesAmount": "Montant ventes",
  "salesTotal": "Total ventes",
  "avgPerSale": "Moyenne par vente"
};

export const workerDashboardModalAr = {
  "title": "نقطة البيع",
  "hello": "مرحباً",
  "close": "إغلاق",
  "tabOverview": "نظرة عامة",
  "tabActiveSession": "الجلسة النشطة",
  "tabReports": "التقارير",
  "tabNotifications": "الإشعارات",
  "tabDeviations": "الانحرافات",
  "bienvenueDansVotreTableauBord": "مرحباً بك في لوحة التحكم",
  "gerezVosVentesSuivezVos": "إدارة مبيعاتك وتتبع أدائك",
  "totalVentes": "إجمالي المبيعات",
  "sessions": "الجلسات",
  "detailPaiementsElectroniques": "تفصيل المدفوعات الإلكترونية",
  "totalPaiementsElectroniques": "إجمالي المدفوعات الإلكترونية",
  "totalVentes2": "من إجمالي المبيعات",
  "transaction": "معاملة",
  "totalElectronique": "من الإلكتروني",
  "totalEspeces": "إجمالي النقد",
  "ceMois": "هذا الشهر",
  "totalElectronique2": "إجمالي الإلكتروني",
  "detailMethodes": "تفصيل الطرق",
  "plus": "أكثر",
  "ventes": "بيع",
  "statutEvaluation": "حالة التقييم",
  "masquer": "إخفاء",
  "afficher": "عرض",
  "utilise": "المستخدم",
  "limite": "الحد الأقصى",
  "maSessionActive": "جلستي النشطة",
  "aucuneSessionActive": "لا توجد جلسة نشطة",
  "vousNAvezPasEncore": "لم تبدأ جلسة عمل بعد",
  "commencee": "بدأت في",
  "duree": "المدة",
  "resumeSession": "ملخص الجلسة",
  "indicateur": "المؤشر",
  "cash": "نقداً",
  "electronic": "إلكتروني",
  "debutSession": "بداية الجلسة",
  "ventesSession": "مبيعات الجلسة",
  "debtCollectionsSession": "تحصيل الديون",
  "sortiesSession": "صادر الجلسة",
  "expected": "المتوقع",
  "electroniqueFournisseur": "الإلكتروني حسب المزود",
  "provider": "المزود",
  "amount": "المبلغ",
  "aucuneTransactionElectroniqueMoment": "لا توجد معاملات إلكترونية بعد",
  "unspecified": "غير محدد",
  "ventesDansCetteSession": "المبيعات في هذه الجلسة",
  "vente": "مبيعة",
  "terminerCetteSessionUtilisezBouton": "لإنهاء هذه الجلسة، استخدم زر تسجيل الخروج",
  "toutesDonneesSessionSerontSauvegardees": "سيتم حفظ جميع بيانات الجلسة تلقائياً",
  "mesRapportsPersonnels": "تقاريري الشخصية",
  "filtrerSessions": "تصفية الجلسات",
  "toutes": "الكل",
  "aujourdHui": "اليوم",
  "cetteSemaine": "هذا الأسبوع",
  "statistiquesMoisActuel": "إحصائيات الشهر الحالي",
  "moyenneSession": "متوسط الجلسة",
  "especes": "نسبة النقد",
  "sessionsTravail": "جلسات العمل",
  "session": "الجلسة",
  "periode": "الفترة",
  "status": "الحالة",
  "debutEspeces": "بداية نقد",
  "finEspeces": "نهاية نقد",
  "debutElectronique": "بداية إلكتروني",
  "sales": "مبيعات",
  "cours": "جارية",
  "terminee": "مكتملة",
  "statusActive": "نشطة",
  "aucuneSessionTrouvee": "لا توجد جلسات",
  "ventesRecentes": "المبيعات الأخيرة",
  "reference": "رقم",
  "date": "التاريخ",
  "modePaiement": "طريقة الدفع",
  "aucuneVenteRecente": "لا توجد مبيعات",
  "analyseDetailleeMethodesPaiementElectroniques": "تحليل مفصل لطرق الدفع الإلكترونية",
  "methodePaiement": "طريقة دفع",
  "transactions": "عدد المعاملات",
  "part": "النسبة",
  "mesNotifications": "إشعاراتي",
  "aucuneNotification": "لا توجد إشعارات",
  "mesEcarts": "انحرافاتي",
  "typeSelf": "انحراف ذاتي",
  "statusAccepted": "مقبول",
  "statusRejected": "مرفوض",
  "statusPending": "معلق",
  "explication": "الشرح",
  "typeHandover": "انحراف تسليم",
  "aucunEcart": "لا توجد انحرافات",
  "monthSummaryTitle": "ملخص الشهر الحالي",
  "periodSummaryTitle": "ملخص الفترة المفلترة",
  "columnIndicator": "المؤشر",
  "columnCount": "العدد",
  "columnAmount": "المبلغ",
  "salesCount": "عدد المبيعات",
  "salesAmount": "مبلغ المبيعات",
  "salesTotal": "إجمالي المبيعات",
  "avgPerSale": "متوسط لكل عملية"
};
